<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form
        :model="state.model"
        ref="formDom"
        class="infoForm"
        style="max-width: 100%"
      >
        <el-form-item
          label="标题"
          prop="title"
          :rules="[{ required: true, message: '请填写标题', trigger: 'blur' }]"
        >
          <el-input v-model="state.model.title" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item label="内容">
          <c_Editor
            style="line-height: normal"
            @change="
              (value) => {
                state.model.content = value;
              }
            "
            :value="state.model.content"
          ></c_Editor>
        </el-form-item>
        <el-form-item label="是否置顶">
          <el-switch
            v-model="state.model.is_top"
            inline-prompt
            active-text="是"
            active-color="#1e90ff"
            inactive-text="否"
            :active-value="1"
            :inactive-value="0"
            style="--el-switch-off-color: #a2a2a2"
          />
        </el-form-item>
        <el-form-item
          label="附件"
          style="display: flex; align-items: flex-start"
        >
          <div style="display: flex; align-items: flex-start">
            <el-upload
              :show-file-list="false"
              :auto-upload="false"
              :multiple="true"
              accept=".jpeg,.jpg,.png,.gif"
              :on-change="onChangeFile"
            >
              <template #trigger>
                <el-button type="primary" size="normal">上传</el-button>
              </template>
            </el-upload>
            <div style="margin-left: 10px">
              <ul
                v-for="(item, index) in state.files"
                :key="item"
                style="display: flex; align-items: center; line-height: 30px"
              >
                <li style="width: 300px; overflow: hidden; height: 30px">
                  {{ item.filename }}
                </li>
                <!-- <el-icon color="#f00" @click="state.files.splice(index, 1)"
                ><Delete
              /></el-icon> -->
                <el-button
                  link
                  icon="delete"
                  type="danger"
                  size="large"
                  @click="state.files.splice(index, 1)"
                ></el-button>
              </ul>
            </div>
          </div>
        </el-form-item>
        <template v-if="props.id">
          <el-form-item label="创建时间">
            <el-input v-model="state.model.create_time" disabled></el-input>
          </el-form-item>
          <el-form-item label="修改时间">
            <el-input v-model="state.model.update_time" disabled></el-input>
          </el-form-item>
        </template>
      </el-form>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  adminnotice_add,
  adminnotice_edit,
  adminnotice_detail,
} from "@/http/api";
import { attachment_upload } from "@/http/attachment";
import { post_response } from "@/utils/qFormat";
import Editor from "@/components/Editor";

export default {
  components: {
    c_Editor: Editor,
  },
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const editorDom = ref(null);
    const formDom = ref(null);
    const state = reactive({
      model: { status: 1 },
      files: [],
    });
    onMounted(() => {
      if (props.id) {
        adminnotice_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data.data;
            state.files = state.model.attachment;
            if (state.model.pid == 0) delete state.model.pid;
          }
        });
      }
    });

    const onChangeFile = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          res.data.data.forEach((e) => {
            state.files.push(e);
          });
        }
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          state.model.attachment = state.files.map((m) => m.id).join(",");

          if (props.id) {
            adminnotice_edit(state.model).then((res) => {
              post_response(res, emit);
            });
          } else {
            adminnotice_add(state.model).then((res) => {
              post_response(res, emit);
            });
          }
        }
      });
    };
    return {
      state,
      props,
      formDom,
      onSubmit,
      editorDom,
      onChangeFile,
    };
  },
};
</script>
<style scoped lang="less"></style>
